import React from 'react'
import { useSelector } from 'react-redux'
import WriteOffActItem from './WriteOffActItem'
import WriteOffActItemsActions from './actions/WriteOffActItemsActions'

const WriteOffActItems = ({ writeOffActId }) => {

    const writeOffAct = useSelector(state => state.writeOff.writeOffAct)

  return (
    <div>
        <h4>Позиції акту</h4>
        {
            writeOffAct.items && writeOffAct.items.length > 0 ?
                <>
                    {/* <SupplyBillItemAgreesAll 
                        supplyBillId={supplyBill.id}
                        supplyBillItems={supplyBill.items}
                    /> */}
                    <WriteOffActItemsActions 
                        writeOffActId={writeOffAct.id}
                    />
                    {
                        writeOffAct.items.map((writeOffActItem, index) => 
                            <WriteOffActItem
                                key={writeOffActItem.id}
                                index={index}
                                writeOffActItem={writeOffActItem} 
                                // checked={checked}
                                // setChecked={setChecked}
                            />
                        )
                    }
                </>
            : 
                <p>Позицій не знайдено</p>
        }
    </div>
  )
}

export default WriteOffActItems